import { render, staticRenderFns } from "./ElectricMetricTable.vue?vue&type=template&id=38f85a42&scoped=true&"
import script from "./ElectricMetricTable.vue?vue&type=script&lang=js&"
export * from "./ElectricMetricTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f85a42",
  null
  
)

export default component.exports